module.exports = __webpack_public_path__ + "img/tjt_reimprimir.22f8e9c3.png";